import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(() => ({
  root: {
    width: 490,
    border: '1px solid #ccc',
    borderRadius: 5,
    marginBottom: 20,
    maxHeight: 400,
    overflow: 'auto',
  },
  accordion: {
    width: 'auto',
    border: 'none',
    maxHeight: 300,
    marginBottom: 0,
  },
  tableRow: {
    cursor: 'pointer',
  },
  tableCell: {
    padding: '5px 20px',
  },
  activeRow: {
    '& td': {
      backgroundColor: '#adffb8',
    },
  },
}));
